import { ContactUsPageTranslations } from '../types';

export const translations: ContactUsPageTranslations = {
  docTitle: 'Contact Us',
  pageTitle: 'Get In Touch',
  beforeUnloadPrompt: 'Do you want to leave this page? Changes you made may not be saved.',
  form: {
    submitSuccessMessage: 'Form was submitted successfully.',
    field: {
      name: {
        label: 'Name',
        placeHolder: 'Name',
        error: {
          required: 'Please enter your Name.',
          tooShort: 'Name must be at least 2 characters long.',
          tooLong: 'Name may not be more than 80 characters in length.'
        }
      },
      email: {
        label: 'Email',
        placeHolder: 'john@sample.com',
        pattern: '^[a-zA-Z0-9_\\-][a-zA-Z0-9_\\.\\-]*@[a-zA-Z0-9][a-zA-Z0-9\\-]*(\\.[a-zA-Z0-9]+)+$',
        error: {
          required: 'Please enter your Email Address.',
          tooShort: 'Please enter a valid Email Address (ex. bobsmith@example.com).',
          tooLong: 'Please enter a valid Email Address (ex. bobsmith@example.com).',
          patternMismatch: 'Please enter a valid Email Address (ex. bobsmith@example.com).'
        }
      },
      details: {
        label: 'Details',
        placeHolder: 'Details of your inquiry',
        error: {
          required: 'Please enter the details of your inquiry.'
        }
      }
    },
    action: {
      submit: {
        label: 'Submit'
      }
    }
  },
  addressContent: [
    '<p><span class="sr-only">Phone number:</span> <a href="tel:+1-866-327-3078" style="white-space:nowrap">1-866-327-3078</a></p>',
    '<p><span class="sr-only">Email:</span> <a href="mailto:info@onguardprotect.com">info@onguardprotect.com</a></p>',
    '<p><span class="sr-only">Address:</span> P.O. Box 3020',
    '<br />Postal Station D',
    '<br />Toronto, Ontario <span style="white-space:nowrap">M9C 4V5</span></p>'
  ].join('\n')
};
